import { FC } from 'react';
import cx from 'classnames/bind';

import Packs from '@/assets/packs.png';
import { Modal } from '@/components/Modal';

import styles from './ModalPointsReceived.module.scss';

interface ModalPointsReceivedProps {
  modal: string;
  setModal: (value: string) => void;
  setStep: (value: number) => void;
}

const cn = cx.bind(styles);

const ModalPointsReceived: FC<ModalPointsReceivedProps> = ({
  modal,
  setModal,
  setStep,
}) => {
  const handleClick = () => {
    setStep(3);
    setModal('');
  };

  return modal === 'pointsReceived' ? (
    <Modal
      src={Packs}
      title="Вы получили все доступные баллы"
      textButton="Продолжить без баллов"
      handleClick={() => handleClick()}
    >
      <div className={cn('modal-description')}>
        <p className={cn('modal-text')}>
          Поздравляем! Возвращайтесь позже, чтобы пройти новые уровни.
        </p>
        <p className={cn('modal-text')}>
          А пока можете продолжить сбор заказов в режиме без баллов.
        </p>
      </div>
    </Modal>
  ) : null;
};

export default ModalPointsReceived;
